import { UploadedFile } from './uploaded-file.model';

export const OBSESSED_ENGINEERING_COMPONENT_SHIPMENT_DAMAGE_CAM_PRESENCE_DAMAGE_ITEM_ID = 'presence';

export interface ObsessedEngineeringComponentShipmentDamageCamEntry {
    damageItemId: string;
    oeComponentShipmentId: string;
    files: UploadedFile[];
    qrScanDate: Date;
    userId: string;
}

export interface ObsessedEngineeringComponentShipmentDamageCamQRCodeDialogArgs {
    oeComponentShipmentId: string;
}
